import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

/**
 * Keeps the included row in sync with the selected variant.
 *
 * The variant picker fetches the whole product URL for the new option values and
 * hands the parsed document to every listener via the product-select event (StandardEvents.productSelect).
 * That document already holds this block rendered by Liquid for the new variant
 * (dumbbell weight, floor area), so this element only morphs itself from its
 * counterpart.
 *
 * The event is dispatched on the variant picker and only bubbles up to the
 * document, so we listen there rather than on our own section.
 */
class WolvIncludedRow extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.productSelect, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.#onVariantUpdate);
  }

  /**
   * @param {Event} event - The variant update event.
   */
  #onVariantUpdate = (event) => {
    // Horizon 4.x: the variant picker dispatches a product-select event whose
    // promise resolves with the freshly rendered product page (detail.html).
    // Selections inside product cards and quick add are not about this page.
    const target = event.target;
    if (!(target instanceof Element) || target.closest('product-card, quick-add-dialog')) return;

    /** @type {any} */ (event).promise
      ?.then((/** @type {any} */ result) => this.#apply(result?.detail?.html))
      .catch((/** @type {any} */ error) => {
        if (error?.name !== 'AbortError') console.warn('[wolv] product select rejected:', error);
      });
  };

  /**
   * @param {Document | undefined} html - The re-rendered product page.
   */
  #apply = (html) => {
    if (!html) return;

    const source = html.querySelector(`wolv-included-row[data-block-id="${this.dataset.blockId}"]`);
    if (!source) return;

    morph(this, source);
  };
}

if (!customElements.get('wolv-included-row')) {
  customElements.define('wolv-included-row', WolvIncludedRow);
}
